import { createSvgIcon } from 'shared/icons/IconUtils';

export const LocationProtectedIcon = createSvgIcon(
  'LocationProtectedIcon',
  <>
    <path
      d="M8 0.666992C9.84 0.666992 11.333 2.16 11.333 4V5.33301H12C12.7333 5.33301 13.333 5.93366 13.333 6.66699V8.35059C13.2947 8.34934 13.2563 8.34766 13.2178 8.34766C11.2968 8.34766 9.73926 9.90518 9.73926 11.8262V12.5215C9.73926 13.3312 10.0165 14.0759 10.4805 14.667H4C3.26667 14.667 2.66699 14.0663 2.66699 13.333V6.66699C2.66699 5.93366 3.26667 5.33301 4 5.33301H4.66699V4C4.66699 2.16 6.16 0.666992 8 0.666992ZM8 8.66699C7.26667 8.66699 6.66699 9.26667 6.66699 10C6.66699 10.7333 7.26667 11.333 8 11.333C8.73333 11.333 9.33301 10.7333 9.33301 10C9.33301 9.26667 8.73333 8.66699 8 8.66699ZM8 1.93359C6.86 1.93359 5.93359 2.86 5.93359 4V5.33301H10.0664V4C10.0664 2.86 9.14 1.93359 8 1.93359Z"
      fill="currentColor"
    />
    <path
      d="M13.2178 9.73901C12.1222 9.73901 11.1309 10.6497 11.1309 12.0581C11.1309 12.9575 11.77 14.0153 13.0456 15.2342C13.1448 15.3276 13.2935 15.3276 13.3926 15.2342C14.6656 14.0153 15.3048 12.9575 15.3048 12.0581C15.3048 10.6497 14.3135 9.73901 13.2178 9.73901ZM13.2178 12.5672C12.9309 12.5672 12.6961 12.3127 12.6961 12.0016C12.6961 11.6905 12.9309 11.4359 13.2178 11.4359C13.5048 11.4359 13.7396 11.6905 13.7396 12.0016C13.7396 12.3127 13.5048 12.5672 13.2178 12.5672Z"
      fill="currentColor"
    />
  </>,
  { viewBox: '0 0 16 16' },
);
